import { clearUserAction } from 'AuthPackage/MainModule/actions/authActions';
import {
  CLIENT_ERROR,
  GATEWAY_TIMEOUT,
  INTERNAL_SERVER_ERROR,
  SERVER_ERROR,
} from 'CorePackage/MainModule/constants/httpErrors';
import { RETURN_URL } from 'CorePackage/MainModule/constants/localStorageNames';
import { store } from 'CorePackage/MainModule/common/store';
import { ROUTE_AUTH } from 'CorePackage/MainModule/routes/routes';

interface IHandleResponseError {
  timestamp?: string;
  status: number;
  statusText?: string;
  error?: string;
  message?: string;
  path?: string;
}

export const handleResponseError = (error: IHandleResponseError | string, isException?: boolean) => {
  const responseError = typeof error === 'object' ? error : undefined;
  const { pathname, search } = window.location;

  if (!responseError) {
    return { text: error };
  }
  const { status } = responseError;

  if (status === 401 && !isException) {
    store.dispatch(clearUserAction());
    if (pathname !== ROUTE_AUTH && pathname !== '/') {
      sessionStorage.setItem(RETURN_URL, pathname + search);
    }
  } else if (status >= 400 && status <= 499) {
    return {
      ...responseError,
      text: CLIENT_ERROR,
    };
  } else if (status === 500) {
    return {
      ...responseError,
      text: INTERNAL_SERVER_ERROR,
    };
  } else if (status === 504) {
    return {
      ...responseError,
      text: GATEWAY_TIMEOUT,
    };
  } else if (status > 500 && status <= 599) {
    return {
      ...responseError,
      text: SERVER_ERROR,
    };
  }

  return {
    ...responseError,
    text: `Ошибка ${status}`,
  };
};
